import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
    AdmitOneParams,
    AdmitParams,
    ParticipantID,
    PollWaitingRoomPayload,
    WaitingRoomPeersSort,
    WaitingRoomPeerState,
} from '../../types';

type WaitingRoomsState = {
    hasNewWaitingRoomPeers: boolean;
    waitingRoomPeers: WaitingRoomPeerState[];
    waitingRoomPeersSort: WaitingRoomPeersSort;
};

const initialState: WaitingRoomsState = {
    hasNewWaitingRoomPeers: false,
    waitingRoomPeers: [],
    waitingRoomPeersSort: WaitingRoomPeersSort.Time,
};

const waitingRoomsSlice = createSlice({
    name: 'waitingRooms',
    initialState: initialState,
    reducers: {
        setHasNewWaitingRoomPeers(state, action: PayloadAction<boolean>) {
            state.hasNewWaitingRoomPeers = action.payload;
        },
        setWaitingRoomPeers(state, action: PayloadAction<WaitingRoomPeerState[]>) {
            state.waitingRoomPeers = action.payload;
        },
        setWaitingRoomPeersSort(state, action: PayloadAction<WaitingRoomPeersSort>) {
            state.waitingRoomPeersSort = action.payload;
        },
        setIsAdmitting(state, action: PayloadAction<{ id: ParticipantID; value: boolean }>) {
            const { id, value } = action.payload;
            for (const peer of state.waitingRoomPeers) {
                if (peer.id === id) {
                    peer.isAdmitting = value;
                    return state;
                }
            }
        },
        resetWaitingRooms() {
            return initialState;
        },
    },
});
export const admitWaitingRoomPeerAction = createAction<AdmitOneParams>('conference/waitingRooms/admitWaitingRoomPeer');
export const admitAllWaitingRoomPeersAction = createAction<Maybe<AdmitParams>>(
    'conference/waiting-rooms/admitAllWaitingRoomPeers'
);
export const showWaitingRoomNotificationsAction = createAction<void>(
    'conference/waitingRooms/showWaitingRoomNotifications'
);

export const showWaitingRoomSidebarAction = createAction<void>('conference/waitingRooms/showWaitingRoomSidebar');

export const startPollWaitingRoomAccessAction = createAction<PollWaitingRoomPayload>(
    'conference/startPollWaitingRoomAccess'
);
export const pollingWaitingRoomSuccessAction = createAction<void>('conference/waitingRooms/pollingWaitingRoomSuccess');
export const pollingWaitingRoomFailedAction = createAction<void>('conference/waitingRooms/pollingWaitingRoomFailed');

export const {
    setHasNewWaitingRoomPeers,
    setWaitingRoomPeers,
    setWaitingRoomPeersSort,
    setIsAdmitting,
    resetWaitingRooms,
} = waitingRoomsSlice.actions;

export const waitingRoomsReducer = waitingRoomsSlice.reducer;
